import React from "react";
import { CheckCircle2 } from "lucide-react";
import { surgicalExpertise } from "../mock";
import Reveal from "./Reveal";

const SurgicalExpertise = () => {
  return (
    <section id="surgical" className="bg-cream">
      <div className="max-w-5xl mx-auto px-4 py-20">
        <Reveal className="text-center mb-12">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold">Procedures</span>
          <h2 className="font-head text-3xl sm:text-4xl uppercase tracking-wide text-navy mt-2">Surgical Expertise</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mt-4" />
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-4">
          {surgicalExpertise.map((s, i) => (
            <Reveal key={s} delay={(i % 2) + 1}>
              <div className="group flex items-center gap-4 bg-white rounded-xl border border-black/5 px-6 py-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
                <span className="w-10 h-10 rounded-lg bg-navy flex items-center justify-center shrink-0 transition-colors group-hover:bg-gold">
                  <CheckCircle2 className="w-5 h-5 text-gold transition-colors group-hover:text-navy" />
                </span>
                <span className="font-medium text-navy">{s}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SurgicalExpertise;
